import type { FaireProductEntity } from "../../entity_types/product";

export const p_ukyg5vku72: FaireProductEntity = {
  token: "p_ukyg5vku72",
  type: "product",
  name: "Handmade Surfboard Resin Earrings – Medium Sterling Silver",
  brandToken: "b_x6hjf3asq3",
  brandName: "Surf Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/afc4a6e6b20357c75fc7722ed39a0e3f21718846de58d618ebb98f846e79a03d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d2cd6f034953c5a991a2da0aad99976ee6bae5bc4fe8ea10b33b4b70c410002.jpeg",
    "https://cdn.faire.com/fastly/b96ca0d23da397566424f0e1a890f2adc8faeaef8f904157703dbe57ff6cec65.jpeg",
    "https://cdn.faire.com/fastly/fc93526767247a8bbfa8678aeb02db74fbf9652e724f34d06636fdae9d615f79.jpeg",
    "https://cdn.faire.com/fastly/fa6d67fb1a395d4140ea12d67a4aa778135b113ecf70cd6bcc146a0785a6faab.jpeg",
    "https://cdn.faire.com/fastly/b5175301f3197999567534aaf0b97e150012a7828780d469cef5cf81243f6e32.jpeg",
    "https://cdn.faire.com/fastly/cca8cc531f85d988fd495aca0f385db5e2ec647f9ad6788b7586680fdac8b6dc.jpeg",
    "https://cdn.faire.com/fastly/0de81cee091936a52c3246f3e8f6fabd2c97715e2966b8471fd531c7ab020a19.jpeg",
    "https://cdn.faire.com/fastly/a50d7c24b52565143dae98b424b7e336fef3f21aa8c1db948725bff3442db737.jpeg",
    "https://cdn.faire.com/fastly/6de161c905a16c923d42aae724b3923ef3b920acec9650dfc4ff6a7f728cd869.jpeg",
    "https://cdn.faire.com/fastly/6207e412dbda57b907cd9bb75c17418328ad08b239bf77e7ff35627da3386394.jpeg",
    "https://cdn.faire.com/fastly/6e6d58c845572470c94ead0c3a027da1536ff34ee88562c2eb4a099a983a2bb8.jpeg",
    "https://cdn.faire.com/fastly/4255956ab068e5a4c7aa710ae61b43245d0f0a7b560dd717f48b622d13b0fb3c.jpeg",
    "https://cdn.faire.com/fastly/e2902b0d37b54dd2ab81ad1b438325567dac287534d133122b7fff9a658246b3.jpeg",
    "https://cdn.faire.com/fastly/080af617fe178ccfa724ba2f29927d9623453a696a2c12621dfe9ed87fd9b6d6.jpeg",
    "https://cdn.faire.com/fastly/7e96d851c71484191b723294c01e6a24c6c80348894bffee1e9071a7b9edd4e8.jpeg",
  ],
  priceDollars: 32.5,
  description:
    'Artist-made earrings handcrafted from reclaimed surfboard resin (surf rock), designed as wearable art with strong retail appeal.\n\nEach piece showcases naturally layered color patterns formed during the surfboard glassing process. No two pairs are the same.\n\nMedium earrings measure approximately 0.75" – 1" in length. Lightweight and comfortable for everyday wear.\n\nWholesale buyers select quantities by size and price. Colorways are thoughtfully curated to provide a cohesive, colorful assortment while maintaining the uniqueness of each piece.\n\nFinished with sterling silver ear wires. Handmade in Morro Bay, California.\n\nInitial orders include gift bags and complimentary wooden retail display that holds up to 20, info board, and sample surf rock. Display dimensions: 11" W × 10" D × 13" H.\n',
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:42.526Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
